// Function to generate a consistent color based on name
export const getColorFromName = (name) => {
    const colors = [
        '#FF1493', // Primary pink
        '#FF69B4', // Light pink
        '#FF4D94', // Medium pink
        '#FF85B3', // Soft pink
        '#FF1464', // Deep pink
    ];
    
    // Generate a consistent index based on the name
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    // Use the hash to pick a color
    const index = Math.abs(hash) % colors.length;
    return colors[index];
};

// Function to get the first letter of each word
export const getInitials = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
}; 